import {delay} from '../helper';

export default {
    defaultConfig: {
        baseUrl: '',
        defaultRequestConfig: {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            throwError: false,
        },
        beforeRequest: null,
        afterRequest: null,
    },
    
    install(Vue, {baseUrl, defaultRequestConfig, beforeRequest, afterRequest}) {
        let querystring;

        Vue.$api = Vue.prototype.$api = {
            async dummyRequest(requestConfig = {}, responseData = {success: true}) {
                console.warn('dummy request', requestConfig);
                await delay(Math.random() * 1000 + 500); // random delay between 500 and 1500ms
                return {response: responseData};
            },
            
            dummyId() {
                return Math.round(Math.random()*10000);
            },

            fetch(url, config = {}) {
                return fetch('//' + baseUrl + url, config);
            },

            async request({url, data = {}, headers = {}, ...config}) {
                config = {
                    ...defaultRequestConfig,
                    ...config,
                    headers: {...defaultRequestConfig.headers, ...headers},
                };

                if (beforeRequest instanceof Function) {
                    await beforeRequest(config);
                }
                if (/get/i.test(config.method)) {
                    if (Object.keys(data).length) {
                        if (!querystring) {
                            querystring = require('querystring');
                        }
                        url += '?' + querystring.stringify(data);
                    }
                    delete config.headers['Content-Type'];
                } else {
                    if (config.headers['Content-Type'].includes('application/json')) {
                        config.body = JSON.stringify(data);
                    }
                }

                let response = await Vue.$api.fetch(url, config);
                let body;
                let isJson = (response.headers['Content']||'').includes('application/json') || (config.headers['Accept']||'').includes('application/json');
                try {
                    body = isJson ? await response.json() : await response.text();
                } catch (e) {
                    if (config.throwError) {
                        throw e;
                    } else {
                        console.error(e);
                        body = isJson ? {} : '';
                    }
                }

                if (typeof body !== "object" || body === null) {
                    body = {body};
                }
                body.$status = response.status;
                body.$success = body.hasOwnProperty('success') ? !!body.success : (body.$status >= 200 && body.$status < 400);

                if (config.throwError && !body.$success) {
                    throw data.message || 'request failed';
                }

                if (afterRequest instanceof Function) {
                    body = await afterRequest(body, response, config);
                }
                return body;
            },

            get(url, data = {}, config = {}) {
                return Vue.$api.request({method: 'get', url, data, ...config});
            },

            post(url, data = {}, config = {}) {
                return Vue.$api.request({method: 'post', url, data, ...config});
            },

            put(url, data = {}, config = {}) {
                return Vue.$api.request({method: 'put', url, data, ...config});
            },

            delete(url, data = {}, config = {}) {
                return Vue.$api.request({method: 'delete', url, data, ...config});
            },
        
            modeRequest(url, mode, data = {}, config = {})  {
                data.mode = mode;
                config.url = url;
                config.data = data;
                return Vue.$api.request(config);
            },
        };
    },
};